import { useState } from "react";
import base from "lib/base";
import styles from "./YouTubeCard.module.css";
import YouTubeModal from "./YouTubeModal";

const YouTubeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

// Extract YouTube video ID from URL
const getYouTubeVideoId = (url) => {
  if (!url) return null;
  const regex =
    /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

export default function YouTubeCard({ video }) {
  const [showModal, setShowModal] = useState(false);

  const videoUrl = video.url || video.videoLink;

  const handleClick = () => {
    if (videoUrl) {
      setShowModal(true);
    }
  };

  // Extract YouTube thumbnail with proper URL handling
  const getThumbnailUrl = () => {
    // If pictures exist, use them
    const pic = video.thumbnail || video.pictures?.[0];
    if (pic) {
      if (pic.startsWith("http")) return pic;
      return `${base.cdnUrl}${pic}`;
    }

    // If no picture, try to get YouTube thumbnail from videoLink
    const videoUrl = video.url || video.videoLink;
    if (videoUrl) {
      const videoId = getYouTubeVideoId(videoUrl);
      if (videoId) {
        return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
      }
    }

    return "/images/placeholder.jpg";
  };

  const thumbnailUrl = getThumbnailUrl();

  return (
    <>
      <div className={styles.card} onClick={handleClick}>
        <div className={styles.thumbnailWrapper}>
          <img
            src={thumbnailUrl}
            alt={video.title || video.name}
            className={styles.thumbnail}
            loading="lazy"
            decoding="async"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          <div className={styles.playButton}>
            <div className={styles.playIcon}></div>
          </div>
          {video.duration && (
            <div className={styles.duration}>{video.duration}</div>
          )}
        </div>
        <div className={styles.content}>
          <div className={styles.badge}>{video.authors?.name || "Author"}</div>
          <h3 className={styles.title}>{video.title || video.name}</h3>
          {video.books?.name && (
            <p className={styles.channel}>{video.books.name}</p>
          )}
        </div>
      </div>

      {showModal && (
        <YouTubeModal videoUrl={videoUrl} onClose={() => setShowModal(false)} />
      )}
    </>
  );
}
